export default "__VITE_ASSET__CRXneu2K__"